import type { HTMLAttributes } from 'react'
import styled from 'styled-components'
import { Loader } from 'components'

type LoadingPagePropsType = HTMLAttributes<HTMLDivElement> & {
  isLoading?: boolean
  bg?: boolean
}

const LoadingPage = ({ isLoading, ...rest }: LoadingPagePropsType) => {
  if (!isLoading) return <Span />
  return (
    <Container {...rest}>
      <Loader />
    </Container>
  )
}

export default LoadingPage

LoadingPage.defaultProps = {
  bg: false,
  isLoading: false,
}

const Span = styled.span`
  position: fixed;
  z-index: -1;
`

const Container = styled.div`
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  position: fixed;
  z-index: ${({ theme }) => theme.zIndex.modal};
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme: { colors } }) => colors.blackFaded};
`
